import { useMemo } from 'react';
import PropTypes from 'prop-types';
import Overlay, { useOverlayTitles } from 'Common/components/modals/Overlay';
import SectionContainer from 'Common/components/modals/SectionContainer';
import CampaignCreateForm from './CampaignCreateForm';
import crudModes from 'Common/constants/crudModes';
import { useTranslation } from 'react-i18next';

const CampaignCreateOverlay = ({ isOpen, onClose, onFormSubmit }) => {
	const { t } = useTranslation();
	const { name, label } = useOverlayTitles(t('Campaign'), crudModes.CREATE);

	const breadcrumbList = useMemo(
		() => [
			{
				label: 'Campains',
				href: '/campains',
			},
			{
				label: name,
			},
		],
		[name],
	);

	return (
		<Overlay
			label={label}
			breadcrumbList={breadcrumbList}
			isOpen={isOpen}
			onClose={onClose}
			onSave={onFormSubmit}
		>
			{(setIsFormDirty, handleSubmit, onCancel) => (
				<SectionContainer name="Campaign">
					<CampaignCreateForm onSubmit={handleSubmit} onCancel={onCancel} onDirty={setIsFormDirty} />
				</SectionContainer>
			)}
		</Overlay>
	);
};

CampaignCreateOverlay.propTypes = {
	onFormSubmit: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	isOpen: PropTypes.bool.isRequired,
};

export default CampaignCreateOverlay;
